import * as React from 'react'
import Table, { TableFilters, TableHeaderValue } from '@components/table/table'
import { TextBlock } from '@modules/cms/models'
import { useAppDispatch, useAppSelector } from '@store/index'
import { useApiRequest } from '@components/hooks/use-api-request'
import { CmsReservationAppTextBlocksRow } from '@modules/cms/reservation-app/text-blocks-row'
import { cmsTextBlocksSelector } from '@store/slices/cms-reservation-app-slice'
import { getCmsTextBlocks } from '@store/actions/cms-reservation-app-actions'

const headerValues: TableHeaderValue<TextBlock>[] = [
  {
    title: 'Nazwa',
  },
  {
    title: 'Identyfikator',
  },

  { title: '' },
]
export const CmsReservationAppTextBlocks: React.FC = () => {
  const [filters, setFilters] = React.useState<TableFilters>({
    ordering: '',
    page: 0,
    page_size: 0,
    search: '',
  })
  const textBlocks = useAppSelector(cmsTextBlocksSelector)
  const dispatch = useAppDispatch()

  const { isLoading, action: fetch } = useApiRequest(async () => await dispatch(getCmsTextBlocks('reservation_app')))

  React.useEffect(() => {
    fetch()
  }, [])

  return (
    <Table
      showPagination={false}
      filters={filters}
      setFilters={setFilters}
      headerValues={headerValues}
      isLoading={isLoading}
    >
      {textBlocks.map(row => (
        <CmsReservationAppTextBlocksRow key={row.id} textBlock={row} />
      ))}
    </Table>
  )
}
